import type { Drawable } from "#internal"

import { FOLD_COLOR_ID } from "../../../data/ColorList"
import { GrowGuides } from "./GrowGuides"
import { PlotRectGuides } from "./PlotRectGuides"

/** The fold lines, one where two pages meet, across the grow where it
 * landed; never where it is cut. */
export const DrawGrowFold: Drawable = node => {
  const grow = node.data?.grow
  if (!grow) return []
  const landed = GrowGuides(node, grow)
  if (!landed) return []
  const { canvas, folds } = landed
  return PlotRectGuides(
    canvas,
    {
      x: folds.x.map(x => x - canvas.x),
      y: folds.y.map(y => y - canvas.y),
    } as typeof folds,
    FOLD_COLOR_ID
  )
}
